import {customAxios} from "../customAxios";
import {useEffect, useState} from "react";
import {SupplierDto} from "../../model/supplier/supplier";

export function useGetSupplierContracts() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<string[]>([]);
    const [error, setError] = useState<Error>();

    useEffect(() => {
        execute();
    }, []);
    async function execute() {
        try {
            setLoading(true);
            setError(undefined);
            const data = await getSupplierContracts();
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getSupplierContracts(): Promise<string[]> {
    const response = await customAxios.get<string[]>('/v1/supplier/contracts', );
    return response.data;
}

